import React from "react";
const isHTMLElement = (value) => value instanceof HTMLElement;
const isFunction = (value) => typeof value === "function";
export const safeStringifyForLog = (value) => {
    try {
        return JSON.stringify(value, (key, value) => {
            if (isFunction(value)) {
                return `function ${value.name}(){...}`;
            }
            if (isHTMLElement(value)) {
                return `${value.outerHTML}`;
            }
            if (React.isValidElement(value)) {
                return `React.Element()`;
            }
            return value;
        });
    }
    catch (ex) {
        return null;
    }
};
